import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [];

if (process.env.NODE_ENV !== "production") {
  routes.push({
    path: "/app/reference-guide",
    name: "reference-guide",
    component: () => import("@common/views/tools/StyleNIconReferencePage.vue")
  });
}
export default routes;
